"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const QwilrPay = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "37", height: "38", viewBox: "0 0 37 38", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        opacity: 0.7,
        d: "M8.8694 24.7224L7.91567 23.5398C7.20997 23.9021 6.38979 24.0929 5.53145 24.0929C2.2698 24.0929 0 21.537 0 18.0464C0 14.5368 2.2698 12 5.53145 12C8.7931 12 11.082 14.5368 11.082 18.0464C11.082 19.7821 10.4907 21.27 9.49879 22.3571L10.4335 23.5016L8.8694 24.7224ZM8.6215 18.0464C8.6215 15.7575 7.40073 14.1744 5.53145 14.1744C3.68128 14.1744 2.47962 15.7575 2.47962 18.0464C2.47962 20.3352 3.68128 21.9756 5.53145 21.9756C5.89387 21.9756 6.2372 21.9375 6.54238 21.8422L5.58868 20.6404L7.15275 19.4388L8.06827 20.5833C8.43076 19.9539 8.6215 19.1146 8.6215 18.0464Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M14.0647 23.1951V27.048H11.6995V15.3748H14.0647V16.0805C14.4462 15.6227 15.2855 15.1841 16.2009 15.1841C18.6806 15.1841 20.0921 17.244 20.0921 19.6474C20.0921 22.0506 18.6806 24.0916 16.2009 24.0916C15.2855 24.0916 14.4462 23.6529 14.0647 23.1951ZM14.0647 18.2359V21.0398C14.3508 21.631 14.9803 22.0316 15.6668 22.0316C16.9449 22.0316 17.7079 21.0016 17.7079 19.6474C17.7079 18.274 16.9449 17.244 15.6668 17.244C14.9611 17.244 14.3508 17.6636 14.0647 18.2359ZM27.9591 23.9008H25.6893V23.443C25.4031 23.7292 24.5448 24.0534 23.6102 24.0534C21.8935 24.0534 20.4439 23.0615 20.4439 21.2877C20.4439 19.6664 21.8935 18.5601 23.7437 18.5601C24.4877 18.5601 25.3459 18.8081 25.6893 19.056V18.4266C25.6893 17.7018 25.2505 17.1105 24.2969 17.1105C23.6292 17.1105 23.2287 17.4157 23.038 17.9115H20.7872C21.0352 16.3666 22.4276 15.1841 24.3732 15.1841C26.643 15.1841 27.9591 16.4239 27.9591 18.4648V23.9008ZM25.6893 21.5739V20.9635C25.4794 20.5057 24.831 20.2196 24.1443 20.2196C23.4003 20.2196 22.6374 20.5438 22.6374 21.2687C22.6374 22.0125 23.4003 22.3177 24.1443 22.3177C24.831 22.3177 25.4794 22.0316 25.6893 21.5739ZM32.5558 27.048H30.2288L31.4685 23.939L28.2068 15.3748H30.7055L32.6703 21.0398L34.6158 15.3748H37L32.5558 27.048Z"
      }
    )
  );
};
export default QwilrPay;
